import { render, staticRenderFns } from "./biletent.vue?vue&type=template&id=5f5cd8a4&"
import script from "./biletent.vue?vue&type=script&lang=js&"
export * from "./biletent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports